import React from 'react'

const FallBack: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Coming Soon...
        </h1>
      </div>
    </div>
  )
}

export default FallBack 